var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-card-section",
    { staticClass: "bg-primary q-px-md q-py-md q-mb-md" },
    [
      _c("div", { staticClass: "row" }, [
        _c("h5", { staticClass: "text-white q-my-none col" }, [
          _vm._v(_vm._s(_vm.title))
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col col-shrink" },
          [
            _vm.dialogCloseButton
              ? _c("q-btn", {
                  staticClass: "dialog-close",
                  attrs: {
                    icon: "close",
                    "text-color": "white",
                    unelevated: ""
                  },
                  on: {
                    click: function($event) {
                      return _vm.$emit("close")
                    }
                  }
                })
              : _vm._e()
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }